import React from "react";
import { Card, Space, Typography, Button } from "antd";
import styled from "styled-components";

interface LogHoursHeader {
  onAddEntryPress: () => void;
}

function LogHoursHeader({ onAddEntryPress }: LogHoursHeader) {
  return (
    <Card style={{ position: "relative" }}>
      <Space direction="vertical" size={25}>
        <Typography.Title>Log Hours</Typography.Title>
      </Space>
      <AddEntryButton type="primary" onClick={onAddEntryPress}>
        Add Entry
      </AddEntryButton>
    </Card>
  );
}

const AddEntryButton = styled(Button)`
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
`;

export default LogHoursHeader;
